module.exports = __webpack_public_path__ + "img/dashboard.94c009ba.svg";